export default "__VITE_ASSET__DJ5O2BDO__"